<template>
  <iRow width="hug">
    <iTextEditInput
      :model-value="`*************`"
      class="hide-cursor"
      label="Password"
      :min-width="400"
      :disabled="editMode"
      editable-on-click
      @click="noop"
    />
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree.
// Canvas preview is a static masked field; password change flow
// lives on FanWeb.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";

export default {
  name: "ChangePassword",
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Change Password Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  methods: {
    noop() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
